var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Axios from "axios";
import { CALL_API } from "../../../middleware/api";
import * as Actions from "../index";
var FPGOLD_GAMES_BASE = "/v1/api/fpgold/games";
var normalizeFilterIds = function (value) {
    if (value == null || value === "")
        return "";
    if (Array.isArray(value))
        return value.filter(Boolean).join(",");
    return String(value);
};
var resolveSortType = function (getState, sortType) {
    if (sortType != null)
        return sortType;
    if (!getState)
        return 0;
    var fromState = getState().games.gamesFilter.providerSortType;
    return fromState != null ? fromState : 0;
};
var normalizeOrderedGroupsResponse = function (res, mode) {
    if (res == null) {
        return { Groups: [], Mode: mode };
    }
    if (typeof res === "object" && res.Code != null && res.Code < 0) {
        return res;
    }
    var rawGroups = null;
    if (Array.isArray(res)) {
        rawGroups = res;
    }
    else if (Array.isArray(res.GameTypes)) {
        rawGroups = res.GameTypes;
    }
    else if (Array.isArray(res.Types)) {
        rawGroups = res.Types;
    }
    else if (Array.isArray(res.Providers)) {
        rawGroups = res.Providers;
    }
    else if (Array.isArray(res.Items)) {
        rawGroups = res.Items;
    }
    else if (Array.isArray(res.Data)) {
        rawGroups = res.Data;
    }
    else {
        rawGroups = [];
    }
    var groups = rawGroups.map(function (group) {
        var games = Array.isArray(group.Games)
            ? group.Games
            : Array.isArray(group.Items)
                ? group.Items
                : Array.isArray(group.Data)
                    ? group.Data
                    : [];
        return __assign(__assign({}, group), { Games: games });
    });
    return { Groups: groups, Mode: mode };
};
var buildGamesListUrl = function (_a) {
    var _b = _a.name, name = _b === void 0 ? "" : _b, _c = _a.types, types = _c === void 0 ? "" : _c, _d = _a.providers, providers = _d === void 0 ? "" : _d, gamblerId = _a.gamblerId, limit = _a.limit, offset = _a.offset, _e = _a.isTop, isTop = _e === void 0 ? null : _e, _f = _a.isNew, isNew = _f === void 0 ? "null" : _f, language = _a.language, sortType = _a.sortType;
    var params = new URLSearchParams();
    if (gamblerId)
        params.append("gamblerId", gamblerId);
    params.append("types", normalizeFilterIds(types));
    params.append("providers", normalizeFilterIds(providers));
    params.append("name", name || "");
    params.append("offset", offset);
    params.append("limit", limit);
    params.append("isMobile", "true");
    params.append("isNew", isNew != null ? isNew : "null");
    params.append("isTop", isTop);
    params.append("language", language != null ? language : "1");
    params.append("sortType", sortType != null ? sortType : 0);
    return "".concat(FPGOLD_GAMES_BASE, "?").concat(params.toString());
};
var dispatchGetGames = function (dispatch, url) {
    var _a;
    return dispatch((_a = {
            type: Actions.GET_GAMES
        },
        _a[CALL_API] = {
            endpoint: url,
            method: "get",
            types: [Actions.SUCCESS_GET_GAMES, Actions.FAILURE_GET_GAMES],
        },
        _a));
};
export function clearGames() {
    return function (dispatch) { return dispatch({ type: Actions.CLEAR_GET_GAMES }); };
}
export function clearRandomGames() {
    return function (dispatch) { return dispatch({ type: Actions.CLEAR_RANDOM_GAMES }); };
}
export function setIsTopGames(isTop) {
    return function (dispatch) { return dispatch({ type: Actions.SET_IS_TOP_GAMES, data: isTop }); };
}
export var setProviderSortType = function (sortType) {
    return function (dispatch) { return dispatch({
        type: Actions.SET_PROVIDER_SORT_TYPE,
        payload: sortType,
    }); };
};
export function fetchFastsportGamesToken(gamblerId) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: Actions.FETCH_FASTSPORT_GAMES_TOKEN
            },
            _a[CALL_API] = {
                endpoint: "/games-tvbet?gamblerid=".concat(gamblerId),
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN,
                    Actions.FAILURE_FETCH_FASTSPORT_GAMES_TOKEN
                ]
            },
            _a));
    };
}
export function getLobbyGames(gamblerId, langId) {
    var params = new URLSearchParams();
    if (gamblerId)
        params.append('gamblerId', gamblerId);
    params.append('limit', 28);
    params.append('language', langId || '1');
    var url = "/v1/api/fpgold/games/lobby?".concat(params.toString());
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: Actions.FETCH_LOBBY_GAMES
            },
            _a[CALL_API] = {
                endpoint: url,
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_LOBBY_GAMES,
                    Actions.FAILURE_FETCH_LOBBY_GAMES
                ],
            },
            _a));
    };
}
export function getMoreGames(_a) {
    var gamblerId = _a.gamblerId, gameType = _a.gameType, _b = _a.limit, limit = _b === void 0 ? 12 : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c, sortType = _a.sortType;
    return function (dispatch, getState) {
        var langId = getState().application.get("languageId");
        var url = buildGamesListUrl({
            gamblerId: gamblerId,
            types: gameType,
            providers: "",
            name: "",
            offset: offset,
            limit: limit,
            isTop: null,
            isNew: "null",
            language: langId || "1",
            sortType: resolveSortType(getState, sortType),
        });
        return dispatchGetGames(dispatch, url);
    };
}
export function getFilterTypes() {
    return function (dispatch, getState) {
        var _a;
        var langId = getState().application.get('languageId');
        return dispatch((_a = {
                type: Actions.FETCH_FILTER_TYPES
            },
            _a[CALL_API] = {
                endpoint: "/v1/api/fpgold/types?language=".concat(langId),
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_FILTER_TYPES,
                    Actions.FAILURE_FETCH_FILTER_TYPES
                ],
            },
            _a));
    };
}
export function getFilterProviders() {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: Actions.FETCH_FILTER_PROVIDERS
            },
            _a[CALL_API] = {
                endpoint: "/v1/api/fpgold/providers",
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_FILTER_PROVIDERS,
                    Actions.FAILURE_FETCH_FILTER_PROVIDERS
                ],
            },
            _a));
    };
}
export var showGamesFilterModal = function (isShow) {
    return function (dispatch) { return dispatch({
        type: Actions.SHOW_GAMES_FILTER_MODAL,
        payload: isShow,
    }); };
};
export var handleSelectFilterOption = function (option, fieldName) {
    return function (dispatch) { return dispatch({
        type: Actions.HANDLE_SELECT_FILTER_OPTION,
        payload: {
            option: option,
            fieldName: fieldName
        }
    }); };
};
export var showFilterConflict = function () {
    return function (dispatch) { return dispatch({
        type: Actions.SHOW_FILTER_CONFLICT
    }); };
};
export var hideFilterConflict = function () {
    return function (dispatch) { return dispatch({
        type: Actions.HIDE_FILTER_CONFLICT
    }); };
};
export var cancelFiltering = function () {
    return function (dispatch) { return dispatch({
        type: Actions.CANCEL_FILTERING
    }); };
};
export var getGamesAction = function (_a) {
    var name = _a.name, types = _a.types, providers = _a.providers, gamblerId = _a.gamblerId, limit = _a.limit, offset = _a.offset, _b = _a.isNew, isNew = _b === void 0 ? null : _b, _c = _a.isTop, isTop = _c === void 0 ? null : _c, sortType = _a.sortType;
    return function (dispatch, getState) {
        var langId = getState().application.get("languageId");
        var url = buildGamesListUrl({
            name: name,
            types: types,
            providers: providers,
            gamblerId: gamblerId,
            limit: limit,
            offset: offset,
            isNew: isNew,
            isTop: isTop,
            language: langId || "1",
            sortType: resolveSortType(getState, sortType),
        });
        return dispatchGetGames(dispatch, url);
    };
};
export var searchGames = function (_a) {
    var _b = _a.name, name = _b === void 0 ? "" : _b, _c = _a.types, types = _c === void 0 ? "" : _c, _d = _a.providers, providers = _d === void 0 ? "" : _d, gamblerId = _a.gamblerId, _e = _a.limit, limit = _e === void 0 ? 12 : _e, _f = _a.offset, offset = _f === void 0 ? 0 : _f, _g = _a.isTop, isTop = _g === void 0 ? null : _g, sortType = _a.sortType;
    return function (dispatch, getState) {
        var langId = getState().application.get("languageId");
        var url = buildGamesListUrl({
            name: name,
            types: types,
            providers: providers,
            gamblerId: gamblerId,
            limit: limit,
            offset: offset,
            isTop: isTop,
            isNew: "null",
            language: langId || "1",
            sortType: resolveSortType(getState, sortType),
        });
        return dispatchGetGames(dispatch, url);
    };
};
export var getAllGames = function (_a) {
    var gamblerId = _a.gamblerId, _b = _a.limit, limit = _b === void 0 ? window.innerWidth < 768 ? 12 : 24 : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c, sortType = _a.sortType;
    return function (dispatch, getState) {
        var langId = getState().application.get("languageId");
        var url = buildGamesListUrl({
            gamblerId: gamblerId,
            types: "",
            providers: "",
            name: "",
            offset: offset,
            limit: limit,
            isTop: null,
            isNew: "null",
            language: langId || "1",
            sortType: resolveSortType(getState, sortType),
        });
        return dispatchGetGames(dispatch, url);
    };
};
export var getRandomGames = function (_a) {
    var _b = _a.offset, offset = _b === void 0 ? 0 : _b, _c = _a.limit, limit = _c === void 0 ? 50 : _c, sortType = _a.sortType;
    return function (dispatch, getState) {
        var _a;
        var params = new URLSearchParams();
        params.append("offset", offset);
        params.append("limit", limit);
        params.append("isMobile", "true");
        params.append("sortType", resolveSortType(getState, sortType));
        var url = "".concat(FPGOLD_GAMES_BASE, "?").concat(params.toString());
        return dispatch((_a = {
                type: Actions.FETCH_RANDOM_GAMES
            },
            _a[CALL_API] = {
                endpoint: url,
                method: "get",
                types: [Actions.SUCCESS_FETCH_RANDOM_GAMES, Actions.FAILURE_FETCH_RANDOM_GAMES],
            },
            _a));
    };
};
export var pinGame = function (gamblerId, gameId) {
    return function (dispatch) {
        dispatch({
            type: Actions.PIN_GAME,
            payload: {
                gameId: gameId,
            },
        });
        Axios.post("/v1/api/fpgold/games/".concat(gameId, "/pin"), {
            gamblerId: gamblerId,
        })
            .catch(function (err) {
            dispatch({
                type: Actions.UNPIN_GAME,
                payload: {
                    error: err.message,
                },
            });
        });
    };
};
export var unPinGame = function (gamblerId, gameId) {
    return function (dispatch) {
        dispatch({
            type: Actions.UNPIN_GAME,
            payload: {
                gameId: gameId,
            },
        });
        Axios.post("/v1/api/fpgold/games/".concat(gameId, "/unpin"), {
            gamblerId: gamblerId,
        })
            .catch(function (err) {
            dispatch({
                type: Actions.PIN_GAME,
                payload: {
                    error: err.message,
                },
            });
        });
    };
};
export var getRecentVisitedGames = function (_a) {
    var gamblerId = _a.gamblerId;
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: Actions.GET_GAMES
            },
            _a[CALL_API] = {
                endpoint: "/v1/api/fpgold/games/history?gamblerId=".concat(gamblerId, "&limit=10"),
                method: "get",
                types: [Actions.SUCCESS_GET_GAMES, Actions.FAILURE_GET_GAMES],
            },
            _a));
    };
};
export var getPinnedGames = function (_a) {
    var gamblerId = _a.gamblerId, limit = _a.limit, offset = _a.offset;
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: Actions.GET_GAMES
            },
            _a[CALL_API] = {
                endpoint: "/v1/api/fpgold/games/pinned?gamblerId=".concat(gamblerId, "&offset=").concat(offset, "&limit=").concat(limit),
                method: "get",
                types: [Actions.SUCCESS_GET_GAMES, Actions.FAILURE_GET_GAMES],
            },
            _a));
    };
};
export var openGame = function (_a) {
    var gamblerId = _a.gamblerId, gameId = _a.gameId, _b = _a.lang, lang = _b === void 0 ? 'ru' : _b, _c = _a.curr, curr = _c === void 0 ? 'KGS' : _c, returnUrl = _a.returnUrl;
    var params = new URLSearchParams();
    if (gamblerId)
        params.append('gamblerId', gamblerId);
    params.append('returnUrl', returnUrl);
    params.append('language', lang);
    params.append('currency', curr);
    params.append('isMobile', 'true');
    var url = "/v1/api/fpgold/games/".concat(gameId, "/launch?").concat(params.toString());
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: Actions.OPEN_GAME
            },
            _a[CALL_API] = {
                endpoint: url,
                method: "get",
                types: [Actions.SUCCESS_OPEN_GAME, Actions.FAILURE_OPEN_GAME],
            },
            _a));
    };
};
export var searchGamesByProvider = function (_a) {
    var providerName = _a.providerName, _b = _a.limit, limit = _b === void 0 ? 12 : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c;
    var params = new URLSearchParams();
    params.append('providerName', providerName);
    params.append('offset', offset);
    params.append('limit', limit);
    params.append('isMobile', 'true');
    var url = "/v1/api/fpgold/games/get-shortlink-games?".concat(params.toString());
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: Actions.SEARCH_GAMES_BY_PROVIDER
            },
            _a[CALL_API] = {
                endpoint: url,
                method: "get",
                types: [Actions.SUCCESS_SEARCH_GAMES_BY_PROVIDER, Actions.FAILURE_SEARCH_GAMES_BY_PROVIDER],
            },
            _a));
    };
};
export var clearOrderedGames = function () {
    return function (dispatch) { return dispatch({ type: Actions.CLEAR_ORDERED_GAMES }); };
};
export var getOrderedGames = function (_a) {
    var types = _a.types, providers = _a.providers, gamblerId = _a.gamblerId, _b = _a.limit, limit = _b === void 0 ? 7 : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c, language = _a.language, sortType = _a.sortType;
    return function (dispatch, getState) {
        var _a;
        var langId = language != null ? language : getState().application.get("languageId");
        var typesStr = normalizeFilterIds(types);
        var providersStr = normalizeFilterIds(providers);
        var hasTypes = typesStr.length > 0;
        var hasProviders = providersStr.length > 0;
        var path;
        var mode;
        var filterValue;
        if (hasProviders && !hasTypes) {
            path = "".concat(FPGOLD_GAMES_BASE, "/get-provider-ordered-games");
            mode = "provider";
            filterValue = providersStr;
        }
        else if (hasTypes && !hasProviders) {
            path = "".concat(FPGOLD_GAMES_BASE, "/get-type-ordered-games");
            mode = "type";
            filterValue = typesStr;
        }
        else {
            return Promise.resolve();
        }
        var params = new URLSearchParams();
        if (gamblerId) {
            params.append("gamblerId", gamblerId);
        }
        params.append(mode === "provider" ? "Providers" : "Types", filterValue);
        params.append("Offset", offset);
        params.append("Limit", limit);
        params.append("Language", langId || "1");
        params.append("sortType", resolveSortType(getState, sortType));
        var url = "".concat(path, "?").concat(params.toString());
        return dispatch((_a = {
                type: Actions.FETCH_ORDERED_GAMES,
                mode: mode
            },
            _a[CALL_API] = {
                endpoint: url,
                method: "get",
                types: [
                    [
                        function (res) { return normalizeOrderedGroupsResponse(res, mode); },
                        Actions.SUCCESS_FETCH_ORDERED_GAMES,
                    ],
                    Actions.FAILURE_FETCH_ORDERED_GAMES,
                ],
            },
            _a));
    };
};



// WEBPACK FOOTER //
// ./src/actions/games/creators/index.js